import { TextField } from '@mui/material'
import { GRID_FORM_CONFIG_T } from '../../../../common/FormGenerator'
import { AvatarUpload } from '../../../../components/ui-kit/AvatarUpload'
import { AutocompleteInput } from '../../../../components/ui-kit/AutocompleteInput'

export type GrowthToolBlockName = 'title' | 'description' | 'image' | 'source_type' | 'content_type'

const sourceTypeOptions = [
    { label: 'Личный опыт', value: 'user' },
    { label: 'Классические источники', value: 'classic' },
    { label: 'Научные материалы', value: 'science' },
    { label: 'Редакция Прогресса', value: 'editorial' },
    { label: 'ИИ', value: 'ai' },
]

const contentTypeOptions = [
    { label: 'Текст', value: 'text' },
    { label: 'Аудио', value: 'audio' },
    { label: 'Видео', value: 'video' },
]

export const titleConfig: GRID_FORM_CONFIG_T<{ title: string }> = [
    [
        {
            id: 1,
            controllerName: 'title',
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: 'Название инструмента (до 240 символов)...',
                fullWidth: true,
                size: 'small',
                inputProps: { maxLength: 240 },
            }),
        },
    ],
]

export const descriptionConfig: GRID_FORM_CONFIG_T<{ description: string }> = [
    [
        {
            id: 2,
            controllerName: 'description',
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: 'Описание инструмента...',
                fullWidth: true,
                multiline: true,
                size: 'small',
                inputProps: { maxLength: 4240 },
            }),
        },
    ],
]

export const imageConfig: GRID_FORM_CONFIG_T<{ image: string }> = [
    [
        {
            id: 3,
            controllerName: 'image',
            RenderElement: AvatarUpload,
            renderProps: () => ({
                hideRemove: true,
            }),
        },
    ],
]

export const sourceTypeConfig: GRID_FORM_CONFIG_T<{ source_type: string[] }> = [
    [
        {
            id: 4,
            controllerName: 'source_type',
            RenderElement: AutocompleteInput,
            renderProps: () => ({
                placeholder: 'Выберите происхождение',
                options: sourceTypeOptions,
                fullWidth: true,
                size: 'small',
                multiple: true,
            }),
        },
    ],
]

export const contentTypeConfig: GRID_FORM_CONFIG_T<{ content_type: string[] }> = [
    [
        {
            id: 5,
            controllerName: 'content_type',
            RenderElement: AutocompleteInput,
            renderProps: () => ({
                placeholder: 'Выберите формат',
                options: contentTypeOptions,
                fullWidth: true,
                size: 'small',
                multiple: true,
            }),
        },
    ],
]

const formConfigs: Record<GrowthToolBlockName, GRID_FORM_CONFIG_T<unknown>> = {
  title: titleConfig as GRID_FORM_CONFIG_T<unknown>,
  description: descriptionConfig as GRID_FORM_CONFIG_T<unknown>,
  image: imageConfig as GRID_FORM_CONFIG_T<unknown>,
  source_type: sourceTypeConfig as GRID_FORM_CONFIG_T<unknown>,
  content_type: contentTypeConfig as GRID_FORM_CONFIG_T<unknown>,
}

export const getFormConfig = (blockName: GrowthToolBlockName) => formConfigs[blockName]
